import classNames from 'classnames';

import Utils from 'utils/utils';

import s from './index.module.scss';

type BarChartSubtitleProps = {
	first: string;
	second: string;
	titleOne?: string;
	titleTwo?: string;
	className?: string;
};

export function BarChartSubtitle({
	first,
	second,
	titleOne,
	titleTwo,
	className,
}: BarChartSubtitleProps) {
	return (
		<div className={s.root}>
			<div className={s.column}>
				{titleOne && <span>{titleOne}</span>}
				<span className={classNames(s.circle, { [`${className}`]: className })}>
					{Utils.moneyFormat(+first)}
				</span>
			</div>

			<div className={s.column}>
				{titleTwo && <span>{titleTwo}</span>}
				<span className={`${s.circle} ${s.circleRed}`}>{Utils.moneyFormat(+second)}</span>
			</div>
		</div>
	);
}
